import {
  useLazyGetAdminSensorsTabQuery,
  useLazyGetVendorOrderSensorsQuery,
  useLazyGetVendorSensorStatusesQuery,
} from "store/api/adminApi"

import { convertAdminSensorsTabToTableRows } from "utils/convertData"
import { WidgetsRow } from "layouts/WidgetsLayout/WidgetsRow"
import { SensorsPageContent } from "components/sensorsTable/SensorsPageContent"
import { useSensorsPage } from "components/sensorsTable/useSensorsPage"
import { WidgetOrderedSensors } from "components/widgets/WidgetOrderedSensors"
import { WidgetSensorStatuses } from "components/widgets/WidgetSensorStatuses"

const Sensors = () => {
  const props = useSensorsPage({
    useLazyQuery: useLazyGetAdminSensorsTabQuery,
    convertData: convertAdminSensorsTabToTableRows,
    listName: "admin_sensors_list",
    tableName: "admin-sensors",
    isVendor: true,
  })

  return (
    <>
      <WidgetsRow>
        <WidgetOrderedSensors useLazyQuery={useLazyGetVendorOrderSensorsQuery} />
        <WidgetSensorStatuses useLazyQuery={useLazyGetVendorSensorStatusesQuery} />
      </WidgetsRow>
      <SensorsPageContent {...props} />
    </>
  )
}

export default Sensors
